export default __webpack_public_path__ + "static/media/Nightcrawler-Fx-Pack-00.3d786ebd.jpg";